import { render, staticRenderFns } from "./CreditsModalButtons.vue?vue&type=template&id=33dff6a6&scoped=true&"
import script from "./CreditsModalButtons.vue?vue&type=script&lang=js&"
export * from "./CreditsModalButtons.vue?vue&type=script&lang=js&"
import style0 from "./CreditsModalButtons.vue?vue&type=style&index=0&id=33dff6a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dff6a6",
  null
  
)

export default component.exports